export const features = {
  ops: {
    runtimeInspectorVisible: "ops.runtime-control.inspector",
    apolloClientConnectToDevTools: "ops.apollo-client.connect-to-devtools"
  },
  pdt: {
    pendo: {
      scriptInjectionEnabled: "pdt.pendo-script-injection"
    },
    createSimpleOperationalHierarchy: {
      manageHierarchyButton:
        "pdt.create-simple-operational-hierarchy.manage-hierarchy-button"
    },
    contextualComments: {
      manageComments: "pdt.enable.opent.contextual-comments"
    }
  },
  dev: {
    amplifyClient: {
      useAmplifyForAllOperations:
        "dev.amplify-client.use-amplify-for-all-operations"
    },
    unitTestFlag: "dev.unit-test-flag",
    springBffPassthrough: {
      searchAndHierarchy: "dev.spring-bff-passthrough-search-and-hierarchy"
    },
    sidebarComponents: {
      example: "dev.sidebar-components.example-component"
    },
    tabComponents: {
      unmountInactive: "dev.pbc.tab-components.unmount-inactive"
    },
    createSimpleOperationalHierarchy: {
      enableDemo: "dev.create-simple-operational-hierarchy.demo"
    },
    boidEdit: {
      showBoidEditTable: "dev.show-boid-edit-table"
    },
    entities: {
      enableCreateNewEntity: "dev.enable-create-new-entity"
    },
    createOrg: {
      createWithTenant: "dev.create-organization-with-tenant"
    },
    supportForm: {
      showSupportForm: "dev.display.common-org-entity.support-form"
    }
  }
};
